import Layout from "../../../components/layout/layout.js";

import Bounty from "../../../components/componentsPage/bounty/index.js";

function BountyPage({ component, ...rest }) {
  return <Layout Component={Bounty} {...rest} controlsDisabled={true} />;
}

export default BountyPage;
